import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { MatIconModule } from '@angular/material/icon';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { TransactionPageComponent } from './transaction-page/transaction-page.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatInputModule } from '@angular/material/input';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { HttpClientModule } from '@angular/common/http';
import { APP_BASE_HREF } from '@angular/common';
import { AutocompleteLibModule } from 'angular-ng-autocomplete';
import { ToastrModule } from 'ngx-toastr';
import { SwinkpayProcessingComponent } from './swinkpay-processing/swinkpay-processing.component';
import { SwinkpaySuccessComponent } from './swinkpay-success/swinkpay-success.component';
import { SwinkpayFailedComponent } from './swinkpay-failed/swinkpay-failed.component';
import { PaymentFailedComponent } from './payment-failed/payment-failed.component';
import { QsFormComponent } from './qs-form/qs-form.component';
import { RewardFormsComponent } from './reward-forms/reward-forms.component';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { RazorpayCheckoutComponent } from './razorpay-checkout/razorpay-checkout.component';
import { RedirectPageComponent } from './redirect-page/redirect-page.component';
import { TcComponent } from './tc/tc.component';
import { SanitizeHtmlPipe } from './pipes/sanitize-html.pipe';
import { CashbackComponent } from './cashback/cashback.component';
import { PaymentPendingComponent } from './payment-pending/payment-pending.component';
import { CampaignSurveyComponent } from './campaign-survey/campaign-survey.component';

@NgModule({
  declarations: [
    AppComponent,
    TransactionPageComponent,
    SwinkpayProcessingComponent,
    SwinkpaySuccessComponent,
    SwinkpayFailedComponent,
    QsFormComponent,
    PaymentFailedComponent,
    RewardFormsComponent,
    RazorpayCheckoutComponent,
    RedirectPageComponent,
    TcComponent,
    SanitizeHtmlPipe,
    CashbackComponent,
    PaymentPendingComponent,
    CampaignSurveyComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    MatAutocompleteModule,
    MatFormFieldModule,
    ReactiveFormsModule,
    FormsModule,
    HttpClientModule,
    MatInputModule,
    MatDatepickerModule,
    MatNativeDateModule,
    AutocompleteLibModule,
    MatCardModule,
    MatButtonModule,
    MatIconModule,
    ToastrModule.forRoot({
      timeOut: 3000,
      positionClass: 'toast-top-right',
      preventDuplicates: true,
    }),
  ],
  providers: [],
  bootstrap: [AppComponent],
})
export class AppModule {}
